import React, { useRef, useEffect } from 'react';
import { useLocalStore, useObserver } from 'mobx-react-lite';
import styled from 'styled-components/macro';
import { useMst } from '../models/WithWineState';
import { StoreFilterOptionsProps } from '../types/StoreFilterOptionsProps';
import StoreFilterOptionsHeader from './StoreFilterOptionsHeader';
import Shrinkable from './Shrinkable';
import Tickbox from './Tickbox';

const UnstyledStoreFilterOptions: React.FC<StoreFilterOptionsProps> = ({
  className,
  children,
  options,
  circular,
  visibleIf,
}) => {
  const stateTree = useMst();
  const state = useLocalStore(() => ({
    close: false,
    height: 1000,
    setHeight(newHeight: number) {
      state.height = newHeight > 0 ? newHeight : 1000; //hack due to race condition where it sometimes gets measured as 0
    },
    toggle() {
      state.close = !state.close;
    },
  }));

  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (ref && ref.current) {
      state.setHeight(ref.current.clientHeight);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options]);

  const isVisible =
    (typeof visibleIf === 'function' ? visibleIf(options) : true) &&
    options &&
    options.length &&
    options.findIndex((o) => o.idValue != null) > -1;

  return useObserver(() =>
    isVisible ? (
      <div className={'ww-store-filter-options ' + className}>
        <StoreFilterOptionsHeader close={state.close} onClick={state.toggle}>
          {children}
        </StoreFilterOptionsHeader>
        <Shrinkable shrink={state.close} height={state.height}>
          <div className="list" ref={ref}>
            {options
              .filter((o) => !o.hidden)
              .map((option) => (
                <Tickbox
                  key={option.id}
                  name={option.id}
                  value={option.idValue ?? option.id}
                  active={option.value}
                  circular={!!circular}
                  onTick={(name) =>
                    stateTree.widgets.storeFilter.searchOptionTick(name)
                  }
                >
                  {option.name}
                </Tickbox>
              ))}
          </div>
        </Shrinkable>
      </div>
    ) : (
      <></>
    ),
  );
};

const StoreFilterOptions = styled(UnstyledStoreFilterOptions)`
  .list {
    padding: 1.154em;
  }
  .ww-tickbox {
    padding-bottom: 1.154em;
  }
  .ww-tickbox:last-child {
    padding-bottom: 0;
  }
`;

export default StoreFilterOptions;
